"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _product = require("@/api/product");
var _validate = require("@/utils/validate");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  name: '',
  productName: ''
};
var _default = exports.default = {
  name: 'cdkey',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      productName: '',
      name: '',
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      returnArr: [{
        name: '随时退',
        code: 1
      }
      // {
      //   name:'指定时间内可退',
      //   code:2
      // },
      // {
      //   name:'指定时间内可退扣减手续费',
      //   code:3
      // },
      ],
      tableFrom: Object.assign({}, tableFroms),
      dialogVisible: false,
      formValidate: {
        type: 1,
        typeName: '',
        startTime: '',
        endTime: '',
        factor: '',
        id: 0
      },
      isShow: false,
      loadingBtn: false,
      ruleValidate: {
        type: [{
          required: true,
          message: '请选择退货类型',
          trigger: 'change'
        }],
        typeName: [{
          required: true,
          message: '请输入退货规则名称',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }, {
          validator: this.validateEndTime,
          trigger: 'change'
        }],
        factor: [{
          required: true,
          message: '请输入扣费比例',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:cdkey:library:page:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 时间比较
    validateEndTime: function validateEndTime(rule, value, callback) {
      var start = this.formValidate.startTime;
      var end = this.formValidate.endTime;
      if (!start || !end) {
        return callback(); // 有一个为空就不验证
      }
      if (new Date(end) < new Date(start)) {
        callback(new Error('结束时间不能早于开始时间'));
      } else {
        callback();
      }
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom = Object.assign({}, tableFroms);
      this.productName = '';
      this.name = '';
      this.getList(1);
    },
    // 添加
    handleAdd: function handleAdd(row) {
      if (row) {
        Object.assign(this.formValidate, row);
      } else {
        this.formValidate.type = 1;
        this.formValidate.typeName = '';
        this.formValidate.startTime = '';
        this.formValidate.endTime = '';
        this.formValidate.factor = '';
        Object.assign(this.formValidate, {
          type: 1,
          id: 0
        });
      }
      this.dialogVisible = true;
    },
    //提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          Object.assign(_this.formValidate, {
            type: 1,
            id: 0
          });
          _this.loadingBtn = true;
          _this.formValidate.id === 0 ? (0, _product.savereturnApi)(_this.formValidate).then(function (res) {
            _this.$message.success('新增成功');
            _this.cancelVisible();
            _this.getList(1);
            _this.loadingBtn = false;
          }).catch(function (res) {
            _this.loadingBtn = false;
          }) : (0, _product.updatereturnApi)(_this.formValidate).then(function (res) {
            _this.$message.success('编辑成功');
            _this.loadingBtn = false;
            _this.cancelVisible();
            _this.getList(1);
          }).catch(function (res) {
            _this.loadingBtn = false;
          });
        }
      });
    }),
    // 列表
    getList: function getList(num) {
      var _this2 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.productName = encodeURIComponent(this.productName);
      this.tableFrom.name = encodeURIComponent(this.name);
      (0, _product.currentlreturnListApi)(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this3 = this;
      this.$modalSure('确定删除此规则吗？').then(function () {
        (0, _product.deletereturnApi)({
          id: id
        }).then(function () {
          _this3.$message.success('删除成功');
          // handleDeleteTable(this.tableData.data.length, this.tableFrom);
          _this3.getList('');
        });
      });
    },
    cancelVisible: function cancelVisible() {
      this.$emit('updateVisible', false);
    }
  }
};